var map = {
	"./assets/adventCalendar/background.png": 3093,
	"./assets/ajinomotoWheel/background.png": 2956,
	"./assets/bmiValentinesDayWheel/background.png": 9994,
	"./assets/christmasFortuneWheel/background.png": 4153,
	"./assets/classicWheel/background.png": 6650,
	"./assets/estivalWheel/background.png": 9332,
	"./assets/grippleWheel/background.png": 2143,
	"./assets/losteWheel/background.png": 3473,
	"./assets/sirhaWheel/background.png": 7181,
	"./assets/stickAndPlayWheel/background.png": 4725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8692;